module.exports = __webpack_public_path__ + "img/xaklogin3.b107ce36.png";